{ combineObjects } = require 'utils/combine-objects'


ORDER_STATUSES   = ['draft', 'pending', 'confirm', 'preparing', 'prepared', 'delivery', 'undo', 'complete']

initOrderSources = (env) ->
  orderSources = ORDER_SOURCES.map (source) =>
    Em.Object.create
      name:  source
      label: env.translate("clients.order_source.#{source}")
      checked: false
  Em.A(orderSources)

Order            = require 'models/order'
initPaymentSources = (env) ->
  paymentSources = Order.PAYMENT_METHODS.map (method) =>
    Em.Object.create
      name:  method
      label: env.translate("order.payment_method.#{method}")
      checked: false
  Em.A(paymentSources)

initDeliveryTypes = (env) ->
  deliveryTypes = DELIVERY_TYPES.map (type) =>
    Em.Object.create
      name:  type
      label: env.translate("order.delivery_type.#{type}")
      checked: false

  Em.A(deliveryTypes)

initPaymentStatuses = (env) ->
  paymentStatuses = ['paid', 'unpaid'].map (method) =>
    Em.Object.create
      name:  method
      label: env.translate("order.payment_status.#{method}")
      checked: false
  Em.A(paymentStatuses)

initSelectedStatuses = ->
  selectedStatuses = ORDER_STATUSES.map (status) =>
    Em.Object.create
      name:  status
      label: "order.status.#{status}"
      checked: false

  Em.A(selectedStatuses)

App.OrdersListController = Em.Controller.extend
  realTimeService: Em.inject.service('realTime')
  env:             Em.inject.service('environment')
  session:         Em.inject.service('session')

  needs: ['orders']

  # todo i18n
  client_rates:      [
    {id: 0, name: 'без оценки'},
    {id: 1, name: '★'},
    {id: 2, name: '★★'},
    {id: 3, name: '★★★'},
    {id: 4, name: '★★★★'},
    {id: 5, name: '★★★★★'},
  ]

  couriersBinding:      'controllers.orders.couriers'
  # restaurantsBinding:   'controllers.orders.restaurants'
  organizationsBinding: 'session.availableOrganizations'

  resraurantsSortOrder: [ 'name' ]
  restaurants: Em.computed.sort('controllers.orders.restaurants', 'resraurantsSortOrder')

  hasOrganizationsFilter: Em.computed.gt('organizations.length', 1)

  loadingState: (->
    if @get('isLoadingOrders')
      if @get('page') is 1
        if @get('orders.length') <= 0
          'fresh-loading'
        else
          'loading'
      else
        'loading-more'
    else
      if @get('orders.length')
        'normal'
      else
        'zero-data'
  ).property(
    'orders.length',
    'isLoadingOrders',
    'page')

  initFilterFields: (->
    @set('selectedStatuses',     initSelectedStatuses(@get('env')))
    @set('orderSources', initOrderSources(@get('env')))
    @set('paymentSources', initPaymentSources(@get('env')))
    @set('paymentStatuses', initPaymentStatuses(@get('env')))
    @set('deliveryTypes', initDeliveryTypes(@get('env')))
  ).on('init')

  isRatesEnabled:      (->
    @get('session.rateEnabled')
  ).property('session.rateEnabled')

  hasOrderTags: (->
    @get('env.features.orderTags')
  ).property('env.features.orderTags')

  

  showPosStatus: (->
    features = combineObjects(@get('organizations').map (organization)=>
      organization.get('features'))
    features.show_pos_status
  ).property('organizations.@each')

  isStateZeroData:     Em.computed.equal('loadingState', 'zero-data')
  isStateLoading:      Em.computed.equal('loadingState', 'loading')
  isStateFreshLoading: Em.computed.equal('loadingState', 'fresh-loading')
  isStateLoadingMore:  Em.computed.equal('loadingState', 'loading-more')
  isStateNormal:       Em.computed.equal('loadingState', 'normal')

  showSpinner: Em.computed.or('isStateLoadingMore', 'isStateFreshLoading')

  isLoadingMoreOrders: false

  orders: []

  bkFilterCourierFood:   false
  selectedArchive:       false
  selectedCouriers:      []
  selectedOrderSources:  []
  selectedDeliveryTypes: []
  selectedPaymentSources:  []
  selectedRestaurants:   []
  selectedDeliveryZones: []
  selectedOrganizations: []
  selectedClientRates:   []
  selectedStatuses:      initSelectedStatuses()

  selectedPaymentStatuses:  []

  deliveryFrom: null
  deliveryTill: null

  deliveryFromOWBinding: Em.Binding.oneWay('deliveryFrom')
  deliveryTillOWBinding: Em.Binding.oneWay('deliveryTill')

  page: 1
  perPage: 50

  pageCount: 0
  totalOrdersCount: 0

  isLoadingOrders: false

  sort: 'published_at'
  sortAscending: false
  sortByNumber        : Ember.computed.equal 'sort', 'number'
  sortByStatus        : Ember.computed.equal 'sort', 'status'
  sortByRestaurant    : Ember.computed.equal 'sort', 'restaurant_id'
  sortByContactName   : Ember.computed.equal 'sort', 'contact_name'
  sortByAddress       : Ember.computed.equal 'sort', 'address'
  sortByClientRate    : Ember.computed.equal 'sort', 'client_rate'
  sortByTag           : Ember.computed.equal 'sort', 'tag'
  sortByPublishedAt   : Ember.computed.equal 'sort', 'published_at'
  sortByDeliveryAt    : Ember.computed.equal 'sort', 'delivery_at'
  sortByFinalSum      : Ember.computed.equal 'sort', 'final_sum'
  sortByPaymentSource : Ember.computed.equal 'sort', 'payment_source'
  sortByCourier       : Ember.computed.equal 'sort', 'courier_id'
  sortBySource        : Ember.computed.equal 'sort', 'source'
  sortByDeliveryZone  : Ember.computed.equal 'sort', 'delivery_zone_id'


  searchQuery: null
  debouncedSearchQuery: null
  debouncedSearchQueryTimeout: null

  filtersDisabled: Em.computed.not('filtersEnabled')
  filtersEnabled:  Em.computed.empty('debouncedSearchQuery')


  canLoadMore: (->
    @get('page') < @get('pageCount')
  ).property('page', 'pageCount')

  debounceSearchQuery: (->
    Em.run.cancel @get('debouncedSearchQueryTimeout')
    if Ember.isEmpty(@get('searchQuery'))
      @set('debouncedSearchQuery','')
      return
    @set('debouncedSearchQueryTimeout', Em.run.later @, ->
        @set('debouncedSearchQuery', @get('searchQuery'))
        @set('debouncedSearchQueryTimeout',null)
      , 2000)
  ).observes('searchQuery')

  filterIsNotEmpty: (->
    q = @get('filterQuery')
    return true if parseInt(q['archive']) != 0
    return true if q['sort'] != 'published_at DESC'
    return Object.keys(q).length > 4
  ).property('filterQuery')

  filterQuery: (->
    order_status = @get('selectedStatuses')
      .filter((s) -> s.checked)
      .map((s) -> s.name)
      .toArray()

    courierIds    = @get('selectedCouriers').map (c) => Em.get(c, 'id')
    restaurantIds = @get('selectedRestaurants').map (r) => Em.get(r, 'id')
    deliveryZonesIds = @get('selectedDeliveryZones').map (r) => Em.get(r, 'id')
    organizationIds = @get('selectedOrganizations').map (r) => Em.get(r, 'id')
    clientRates = @get('selectedClientRates').map (r) => Em.get(r, 'id')
    selectedOrderSourcesValues = @get('selectedOrderSources').map (r) => Em.get(r, 'name')
    selectedDeliveryTypesValues = @get('selectedDeliveryTypes').map (r)=> Em.get(r, 'name')
    selectedPaymentSourcesValues = @get('selectedPaymentSources').map (r) => Em.get(r, 'name')
    selectedPaymentStatusesValues = @get('selectedPaymentStatuses').map (r) => Em.get(r, 'name')

    searchQuery     = @get 'debouncedSearchQuery'

    sort            = @get 'sort'
    sortAscending   = @get 'sortAscending'
    sort += if sortAscending then ' ASC' else ' DESC'

    deliveryFrom = @get('deliveryFrom')
    deliveryTill = @get('deliveryTill')

    result = {
      sort: sort
    }

    if !Ember.isEmpty deliveryFrom
      deliveryFrom = moment(deliveryFrom).hours(0).minutes(0).toISOString()

    if !Ember.isEmpty deliveryTill
      deliveryTill = moment(deliveryTill).hours(23).minutes(59).toISOString()

    if !Ember.isEmpty(searchQuery)
      result.q = searchQuery
    else
      Em.merge(result, _.omit({
        status: order_status,
        organization_id: organizationIds,
        bk_filter_courier_food: (if @get('bkFilterCourierFood') then 1 else null),
        archive: (if @get('selectedArchive') then 1 else 0),
        restaurant_id: restaurantIds,
        delivery_zone_id: deliveryZonesIds,
        courier_id: courierIds,
        source: selectedOrderSourcesValues,
        delivery_types: selectedDeliveryTypesValues,
        payment_source: selectedPaymentSourcesValues,
        payment_status: selectedPaymentStatusesValues,
        client_rate: clientRates,
        delivery_from: deliveryFrom,
        delivery_till: deliveryTill
      }, (v) -> Em.isEmpty(v)))

    result
  ).property(
    'filtersEnabled',
    'debouncedSearchQuery',
    'sort',
    'sortAscending',
    'isRatesEnabled',
    'deliveryFrom',
    'deliveryTill',
    'selectedStatuses.@each.checked',
    'bkFilterCourierFood',
    'selectedOrganizations.[]',
    'selectedRestaurants.[]',
    'selectedArchive',
    'selectedDeliveryZones.[]',
    'selectedPaymentSources.[]',
    'selectedPaymentStatuses.[]',
    'selectedOrderSources.[]',
    'selectedCouriers.[]',
    'selectedClientRates.[]'
    'selectedDeliveryTypes.[]')

  manualRefresh: true

  onFilterChanged: (->
    @set('page', 1)
    @loadOrdersPortion()
  ).observes(
    'filterQuery',
    'manualRefresh' )


  loadOrdersPortion: ->
    return if @get('isLoadingOrders')

    page        = @get('page')
    per_page    = @get('perPage')
    filterQuery = @get('filterQuery')

    query = Em.merge(filterQuery, { page, per_page })

    @set('isLoadingOrders', true)
    @store.find('order', query)
      .then (orders) =>
        orders = orders.filter((order) => order.get('parent_id') == null)

        if page is 1
          @set('orders', orders.toArray() )
        else
          @get('orders').pushObjects( orders.toArray() )

        meta = @store.metadataFor('order')
        @set('pageCount', meta.page_count)
        @set('totalOrdersCount', meta.count)
      .finally =>
        @set('isLoadingOrders', false)

        # не очень хорошо, но нужно, чтобы избежать проблем
        # когда заказы не доходят до конца страницы и больше не грузятся
        @get('ordersTableComponent').onScroll()

  deliveryZones: Ember.computed(->
    @store.find 'delivery-zone'
  )

  actions:
    exportCSV: ->
      adapter = @get('store').adapterFor('application')
      token   = @get('session.apiKey')

      url = adapter.buildURL('order')

      queryParams = Em.$.param(Em.merge(@get('filterQuery'), {
        all: true,
        token: token
      }))
      csvLink = "#{url}.csv?#{queryParams}"
      window.open(csvLink, '_blank')

      false

    exportXLS: ->
      adapter = @get('store').adapterFor('application')
      token   = @get('session.apiKey')

      url = adapter.buildURL('order')

      queryParams = Em.$.param(Em.merge(@get('filterQuery'), {
        all: true,
        token: token
      }))
      xlsLink = "#{url}.xlsx?#{queryParams}"
      window.open(xlsLink, '_blank')

      false

    updateDeliveryFrom: (date) ->
      @set('deliveryFrom', date)
      false

    updateDeliveryTill: (date) ->
      @set('deliveryTill', date)
      false

    orderSelected: (order) ->
      @transitionToRoute('orders.list.order', order.get('id'))
      false

    loadMore : ->
      return if @get('isLoadingOrders')
      return unless @get('canLoadMore')

      @incrementProperty('page')
      @loadOrdersPortion()
      false

    createOrderWithinOrganization: (organization) ->
      return if @get('isCreateOrderLoading')

      @set('isCreateOrderLoading', true)

      order = @store.createRecord 'order',
        organization: organization,
        source: 'board'

      order.save()
      .then =>
        @send('showOrderModal',    order)
        @send('appendOrderToList', order)
      .finally =>
        @set('isCreateOrderLoading', false)
        @set('isCreatePopoverOpened', false)

      false

    createOrder: ->
      # Если одна организация, то сразу создаем заказ в ней
      if !@get('multipleOrganizations')
        organization = @get('organizations.firstObject')
        @send('createOrderWithinOrganization', organization)

      false

    openOrder: (order) ->
      if order
        @transitionToRoute 'orders.list.order', order.get('id')
      else
        @transitionToRoute 'orders.list'
      false

    openTimePopup: (order) ->
      @set('popupOrder', order)
      @get('miniPopups').send('openPopup', 'time-popup')
      false

    openStatusPopup: (order) ->
      # черновому заказу нельзя поменять статус, поэтому открываем сразу
      # модальник заказа
      if order.get('isDraft')
        @send('openOrder', order)
      else
        @set('popupOrder', order)
        @get('miniPopups').send('openPopup', 'status-popup')
      false

    openCourierPopup: (order) ->
      @set('popupOrder', order)

      restaurant = order.get('restaurant.id')
      @set(
        'popupOrderCouriers',
        @get('couriers').filter (el)->
          # у пользователя могут быть недоступны рестораны, к которых относится курьер,
          # делаем фильтрацию таким образом, чтобы не инициировать запрос недоступных ресторанов
          !el.get('disabled') && el._data.restaurants.length == 0 || el._data.restaurants.map((v) -> v.id).indexOf(restaurant) > -1
          # !el.get('disabled') && (el.get('restaurants.length') == 0 || el.get('restaurants').map((v) -> v.id).indexOf(restaurant) > -1)
      )


      @get('miniPopups').send('openPopup', 'courier-popup')
      false

    sortBy: (propertyName) ->
      sort = @get 'sort'

      if sort is propertyName
        @toggleProperty 'sortAscending'
        return

      @set 'sort', propertyName
      false
